import React from 'react';
import ReactDOM from 'react-dom';
import { App } from './Components/index';

ReactDOM.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
  document.getElementById('root')
);


